import React, { useRef, useState } from 'react'
import classes from './AgentAlertItem.module.css'
import './AgentAlertItem.module.css'
import whatsapp from '../../../../assets/whatsapp.png';
import sms from '../../../../assets/sms.png';
import instagram from '../../../../assets/instagram.png';
import messenger from '../../../../assets/messenger.png';
import mail from '../../../../assets/mail.png'
import companyIcon from '../../../../assets/home.png'
import facebookIcon from '../../../../assets/facebook.png'
import leadIcon from '../../../../assets/lead3.jpg'
import contactIcon from '../../../../assets/contact-icon.png'
import instagram_direct from '../../../../assets/instagram_direct.png'
import youtube from '../../../../assets/youtubeIcon.png'
import webchat from '../../../../assets/webchaticon.png'
import { convertDateTimeToApplicationTime } from '../../../../util/functions'
import { useTranslation } from "react-i18next"
import Flatpickr from "react-flatpickr";


const AgentAlertItem = React.memo((props) => {
    const [t] = useTranslation('common')
    const FlatpickrRef = useRef()
    const [flatpickrValue, setFlatpickrValue] = useState(new Date(props.date))

    let Icon = whatsapp
    switch (props.iconName) {
        case 'whatsapp':
            Icon = whatsapp
            break;
        case 'sms':
            Icon = sms
            break;
        case 'ig_media':
            Icon = instagram
            break;
        case 'messenger':
            Icon = messenger
            break;
        case 'mail':
            Icon = mail
            break;
        case 'company':
            Icon = companyIcon
            break;
        case 'facebook':
            Icon = facebookIcon
            break;
        case 'instagram':
            Icon = instagram_direct
            break;
        case 'lead':
            Icon = leadIcon
            break;
        case 'contact':
            Icon = contactIcon
            break;
        case 'youtube':
            Icon = youtube
            break;
        case 'webchat':
            Icon = webchat
            break;
        default:
            Icon = whatsapp
    }

    let title = ''
    if (props.title) {
        title = props.title.startsWith('+972') ? props.title.replace('+972', '0') : props.title
    }

    let date = convertDateTimeToApplicationTime(new Date())
    if (props.date) {
        date = convertDateTimeToApplicationTime(new Date(props.date))
    }

    let cssClassActionColor = ''
    switch (props.actionsBtnColor) {
        case 'RED':
            cssClassActionColor = classes['alert-action-red']
            break;
        case 'BLUE':
            cssClassActionColor = classes['alert-action-blue']
            break;
        default:
            cssClassActionColor = ''
    }

    const dataSelectedHandler = () => {
        console.log(FlatpickrRef.current.flatpickr.latestSelectedDateObj)
        const updateObject = {
            notificationTime: FlatpickrRef.current.flatpickr.latestSelectedDateObj
        }
        props.onRejectClicked(props.id, updateObject)
    }

    const dateSelectedHandler = (date) => {
        setFlatpickrValue(date)
    }

    return (
        <li onClick={props.onClick} className={classes['alert-container']}>
            <div className={`${classes['channel-image-container']} `}>
                <img className={`${classes['channel-img']} ${props.iconName === 'contact' && classes['channel-img--contact']}`} src={Icon} alt="Channel" />
            </div>
            <div className={classes['alert-details-container']}>
                <header className={classes['alert-header']}>
                    <p className={classes['alert-channelID']}>
                        {title}
                    </p>
                </header>
                <article className={classes['alert-body']}>
                    <p className={classes['alert-reason']}>
                        {props.body}
                    </p>
                </article>
                <footer className={classes['alert-bottom']}>
                    <div>
                        <i className={`fa-solid fa-trash fa-sm ${classes['alert-action']} ${cssClassActionColor}`} title={t('delete')} onClick={(e) => { e.stopPropagation(); props.onDeleteClicked(props.id); }} />
                        <Flatpickr options={{ time_24hr: true, static: true }} onClose={dataSelectedHandler} ref={FlatpickrRef} value={flatpickrValue} onChange={dateSelectedHandler} className={classes['time-picker']} data-enable-time />
                        <i className={`fa-solid fa-calendar-days fa-sm ${classes['alert-action']} ${cssClassActionColor}`} title={t('reject')} onClick={(e) => { e.stopPropagation(); FlatpickrRef.current.flatpickr.open(); }} />
                    </div>
                    <span className={classes['alert-time']}>
                        {date}
                    </span>


                </footer>
            </div>
        </li>
    )
})

export default AgentAlertItem

// 